import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';

export function useAuth() {
  const { isAuthenticated, isLoading, initialize, customer, customers } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    initialize();
  }, [initialize]);

  useEffect(() => {
    if (isLoading) return;

    // Don't redirect if we're on the login callback page (processing token)
    if (location.pathname === '/login') return;

    if (!isAuthenticated) {
      // Redirect to auth service login
      const authWebUrl = import.meta.env.VITE_AUTH_WEB_URL || 'https://auth.lynki.no';
      const clientId = import.meta.env.VITE_AUTH_CLIENT_ID || '11111111-1111-1111-1111-111111111111';
      window.location.href = `${authWebUrl}/login?clientId=${clientId}&returnUrl=${encodeURIComponent(window.location.href)}`;
      return;
    }

    // If authenticated but no customer selected and multiple customers available
    if (isAuthenticated && !customer && customers.length > 1 && location.pathname !== '/select-customer') {
      navigate('/select-customer');
    }
  }, [isAuthenticated, isLoading, customer, customers, navigate, location.pathname]);

  return { isAuthenticated, isLoading };
}

export default useAuth;
